// extracted by mini-css-extract-plugin
export var main = "app-shell-module--main--c7564";
export var root = "app-shell-module--root--1e08a";